// extracted by mini-css-extract-plugin
export var expanded = "mainnav-list-module--expanded--RuMH+";
export var hasActiveItem = "mainnav-list-module--hasActiveItem--RQLMk";
export var mainNavList = "mainnav-list-module--mainNavList--G9Ypg";